<template>
    <div class="graph-mode">
        <task-menu :isOpen="taskMenu" :taskHouseInfo="taskHouseInfo" @taskClose="closeTaskMenu"></task-menu>
        <div class="left">
            <district-house v-for="(houseItem, index) in houseResult" :key="index" :county="houseItem.county" :total="houseItem.total" :district="houseItem.district" :house="houseItem.houseList" @getHouseInfo="getHouse"></district-house>
            <district-house v-if="houseResult.length == 0 && !houseIsLoading" :noHouse="true"></district-house>
        </div>
        <div class="right">
            <div class="filter" :class="{'fixed': filterIsFixed}">
                <div class="filter-title">
                    <span>
                        <img src="@/assets/img/icon/filter_gray.svg" alt="">
                        篩選
                    </span>
                    <span v-show="filterState" class="clear-filter" @click="setFilterDefault">
                        清除篩選
                    </span>
                </div>
                <div class="filter-todo-list">
                    <div class="todo-state">
                        <span class="title">空房</span>
                        <div class="todo-state-wrap">
                            <div class="todo-state-wrap-empty">
                                <div class="check-box-wrap">
                                    <rent-checkbox ref="empty" v-model="filter.status" val="0" checkboxMsg="空房待租" tickColor="black" bgColor="#fff" borderColor="#d5dad8"  :setDefault="isDefault"></rent-checkbox>
                                    <span>{{statusCount(0)}}</span>
                                </div>
                                <div class="check-box-wrap">
                                    <rent-checkbox  ref="beSigned" v-model="filter.status" val="1" checkboxMsg="房客預定" tickColor="white" bgColor="#71aae5" borderColor="#71aae5"   :setDefault="isDefault"></rent-checkbox>
                                    <span>{{statusCount(1)}}</span>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="filter-todo-list">
                    <div class="todo-state">
                        <span class="title">已租</span>
                        <div class="todo-state-wrap">
                            <div class="todo-state-wrap-rented">
                                <div class="check-box-wrap">
                                    <rent-checkbox  ref="notEmpty" v-model="filter.status" val="5" checkboxMsg="已租無待辦" tickColor="black" bgColor="#fff" borderColor="#848b88"  :setDefault="isDefault"></rent-checkbox>
                                    <span>{{statusCount(5)}}</span>
                                </div>
                                <!-- <div class="check-box-wrap">
                                    <rent-checkbox  ref="tanantConfirm" v-model="filter.status" val="1" checkboxMsg="待租客確認" tickColor="white" bgColor="#3942b5" borderColor="#3942b5" :setDefault="isDefault"></rent-checkbox>
                                    <span>{{statusCount(1)}}</span>
                                </div> -->
                                <div class="check-box-wrap">
                                    <rent-checkbox  ref="arrears" v-model="filter.status" val="2" checkboxMsg="欠款" tickColor="white" bgColor="#fc7171" borderColor="#fc7171"  :setDefault="isDefault"></rent-checkbox>
                                    <span>{{statusCount(2)}}</span>
                                </div>
                                <div class="check-box-wrap">
                                    <rent-checkbox  ref="expiring" v-model="filter.status" val="3" checkboxMsg="快到期" tickColor="white" bgColor="#676362" borderColor="#676362"  :setDefault="isDefault"></rent-checkbox>
                                    <span>{{statusCount(3)}}</span>
                                </div>
                                <div class="check-box-wrap">
                                    <rent-checkbox  ref="rent" v-model="filter.status" val="4" checkboxMsg="收款提醒" tickColor="white" bgColor="#fcb773" borderColor="#fcb773"  :setDefault="isDefault"></rent-checkbox>
                                    <span>{{statusCount(4)}}</span>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="filter-group">
                    <span v-if="isAllGroup" class="title">業務分群</span>
                    <rent-select v-if="isAllGroup" refName="orgGroup" style="margin-bottom: 16px;" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li v-for="(item, index) in groupList" :key="index" :data-id="item.id" :data-name="item.groupName">
                                {{item.groupName}}
                            </li>
                        </ul>
                    </rent-select>
                    <span class="title">業務</span>
                    <rent-select refName="member" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li v-for="(item, index) in memberList" :key="index" :data-id="item.userCid" :data-name="item.name">
                                {{item.name}}
                            </li>
                        </ul>
                    </rent-select>
                </div>
                <div class="filter-lease-term">
                    <span class="title">租期</span>
                    <date-picker :class="{'active': filter.leaseTerm[0] != null}" v-model="filter.leaseTerm" placeholder="2020.05.06-2020.05.06" format="YYYY.MM.DD" rangeSeparator="-" range  ></date-picker>
                </div>
                <div class="filter-lease-type">
                    <span class="title">出租類型</span>
                    <rent-select refName="houseType" selectMsg="所有類型" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li data-id="1">
                                整層住家
                            </li>
                            <li data-id="2">
                                套房
                            </li>
                            <li data-id="3">
                                雅房
                            </li>
                        </ul>
                    </rent-select>
                </div>
                <div class="filter-house-type">
                    <span class="title">房屋類型</span>
                    <rent-select refName="buildingType" selectMsg="所有類型" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li data-id="1">
                                公寓
                            </li>
                            <li data-id="2">
                                電梯大樓
                            </li>
                            <li data-id="3">
                                透天
                            </li>
                            <li data-id="4">
                                別墅
                            </li>
                        </ul>
                    </rent-select>
                </div>
                <div class="filter-house-rent">
                    <span class="title">房屋金額</span>
                    <vue-slider v-model="filter.rent" :min="0" :max="100000" :width="214" :height="2" tooltip="always" :tooltip-placement="'bottom'" :tooltip-formatter="val => numValue(val)" :enableCross="true"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DistrictHouse from '@/components/bussiness/personalHome/todoList/graphMode/DistrictHouse.vue';
import VueSlider from 'vue-slider-component'
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import TaskMenu from '@/components/bussiness/widges/menu/bizTaskMenu.vue';
import RentCheckbox from '@/components/widge/RentCheckbox.vue';
import DatePicker from 'vue2-datepicker';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            filter: {
                group: null,
                member: null,
                empty: ['0','1'],
                // status: ['0','1','2','3','4'],
                status: ['0','1','2','3','4','5',],
                leaseTerm: [null, null],
                houseType: '',
                buildingType: '',
                rent: [0, 100000],
            },
            filterState: 0,
            filterIsFixed: false,
            taskMenu: false,
            taskHouseInfo: {},
            isDefault: false,
            componentKey: 0
        }
    },
    mounted () {
        this.$store.dispatch('getBizTodoListGraph')
        if(!this.isAllGroup){
            this.$store.dispatch('getBizMemberByGroupList', this.groupId)
        }
    },
    watch: {
        filter: {
            handler: function (newValue, oldValue) {
                this.$store.dispatch('setBizTodoListGraphFilter',this.filter)
                this.filterState = 1
            },
            deep: true
        },
    },
    methods: {
        getSelectId: function (value) {
            this.filterState = 1
            this.isDefault = false
                console.log(value)
            if( value.ref == 'orgGroup' ){
                this.filter.group = value.name
                this.$store.dispatch('getBizMemberByGroupList',(value.id))
            }else if( value.ref == 'member' ){
                this.filter.member = value.name
            }else if( value.ref == 'houseType' ){
                this.filter.houseType = value.id
            }else if( value.ref == 'buildingType' ){
                this.filter.buildingType = value.id
            }
        },
        getHouse: function (value) {
            let allowStatus = this.$store.getters.DEFAULT_FILTER_STATUS
            let status = value.status.map( item => {
                if(allowStatus.includes(item)){
                    return item
                }
            })
            // console.log(status[0])
            // if(status[0] == undefined){
            //     this.taskMenu = false
            //     this.alart.success = true
            //     this.msg.success = '待辦事項已清空囉'
            // }else if(status.length > 0 || value.notRateTenant.length > 0){
                this.taskMenu = true
                this.taskHouseInfo = value
            // }
        },
        closeTaskMenu: function (value) {
            this.taskMenu = value
        },
        setFilterDefault: function () {
            this.filter.group = null
            this.filter.member = null
            this.filter.empty = ['0','1']
            this.filter.status= ['0','1','2','3','4','5']
            this.filter.houseType = ''
            this.filter.buildingType = ''
            this.filter.rent = [0, 100000]
            this.isDefault = true
            setTimeout(()=>{
                this.filterState = 0
                this.isDefault = false
            },100)
        },
        handleScroll: function () {
            // console.log(event.path[1].scrollY)
            if( event.path[1].scrollY >= 178){
                this.filterIsFixed = true
            }else{
                this.filterIsFixed = false
            }
        },
        numValue: function (val) {
            if( val == '100000' ){
                return '$'+this.toCurrency(val)+'+'
            }else{
                return '$'+this.toCurrency(val)
            }
        },
        removeEmpty: function (val) {
            this.filter.empty.map((item, index) => {
                if(item == val){
                    this.filter.empty.splice(index, 1)
                }
            })
        },
        pushEmpty: function (val) {
            let isHas = false
            this.filter.empty.map((item, index) => {
                if(item == val){
                    isHas = true
                }
            })
            if(!isHas){
                this.filter.empty.push(val)
            }
        },
        removeStatus: function (val) {
            this.filter.status.map((item, index) => {
                if(item == val){
                    this.filter.status.splice(index, 1)
                }
            })
        },
        pushStatus: function (val) {
            let isHas = false
            this.filter.status.map((item, index) => {
                if(item == val){
                    isHas = true
                }
            })
            if(!isHas){
                this.filter.status.push(val)
            }
        },
        statusCount: function (status) {
            let count = 0
            this.fileterByDistrict.map(houseList => {
                houseList.houseList.map(house => {
                    if(house.status.includes(status)){
                        count += 1
                    }
                })
            })
            return count
        }
    },
    computed: {
        fileterByCounty: function () {
            return this.houseResult.filter((houseItem) => {
                // console.log(this.filterQuery.county)
                if(this.filterQuery.county){
                    if(houseItem.county.includes(this.filterQuery.county) == true){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        fileterByDistrict: function () {
            return this.fileterByCounty.filter((houseItem) => {
                // console.log(houseItem)
                if( this.filterQuery.district){
                    if(houseItem.district.includes(this.filterQuery.district) == true){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        ...mapGetters({
            filterQuery: 'BIZ_TODO_LIST_GRAPH_FILTER_QUERY',
            houseResult: 'BIZ_TODO_LIST_GRAPH_HOUSE_RESULT',
            houseIsLoading: 'BIZ_TODO_LIST_GRAPH_HOUSE_STATUS_LOADING',
            groupList: 'GET_ORG_GROUP_LIST',
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            memberList: 'GET_ORG_MEMBER_BY_GROUP_LIST',
            groupId: 'GET_BIZ_GROUP_ID'
        })
    },
    components: {
        DistrictHouse,
        VueSlider,
        TaskMenu,
        RentCheckbox,
        DatePicker,
        RentSelect,
    }
}
</script>
<style lang="scss" scoped>
    .graph-mode{
        display: flex;
        justify-content: space-between;
        .right{
            position: relative;
            width: 270px;
            .clear-filter{
                position: absolute;
                cursor: pointer;
                font-size: 12px;
                color: #ff9275;
                top: 24px;
                right: 17px;
            }
            .filter::-webkit-scrollbar{
                display: none;
            }
            .filter{
                position: relative;
                width: 270px;
                backdrop-filter: blur(10px);
                box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
                border: solid 1px #f3f3f3;
                background-color: #ffffff;
                border-radius: 6px;
                border: solid 1px #f0f0f0;
                padding: 20px 0px 25px 0px;
                .title{
                    display: block;
                    font-size: 16px;
                    margin-bottom: 16px;
                }
                .filter-title,
                .filter-todo-list,
                .filter-group,
                .filter-lease-term,
                .filter-lease-type,
                .filter-house-type,
                .filter-house-country,
                .filter-house-rent{
                    padding: 0 20px 20px 20px;
                    border-bottom:2px solid #f6f6f6 ;
                }
                .filter-title{
                    span:nth-child(1){
                        display: flex;
                        align-items: center;
                        color: #a8a5a4;
                        img{
                            margin-right: 8px;
                        }
                    }
                }
                .filter-todo-list{
                    padding-top: 20px;
                    padding-bottom: 0px;
                    .todo-button{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-weight: 300;
                        width: 230px;
                        height: 44px;
                        color: #676362;
                        border-radius: 4px;
                        background-color: #f6f6f6;
                        margin-bottom: 20px;
                        cursor: pointer;
                    }
                    .todo-state{
                        .todo-state-wrap{
                            .todo-state-wrap-empty{
                                display: flex;
                                flex-direction: column;
                                >div{
                                    margin-bottom: 17px;
                                }
                            }
                            .todo-state-wrap-rented{
                                display: flex;
                                flex-direction: column;
                                >div{
                                    margin-bottom: 17px;
                                }
                            }
                            .check-box-wrap{
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                span{
                                    color: #a8a5a4;
                                }
                            }
                        }
                    }
                }
                .filter-group{
                    padding-top: 20px;
                    .group{
                        display: flex;
                        .biz-rent-select:nth-child(1){
                            margin-right: 10px;
                        }
                        .biz-rent-select{
                            width: 83px;
                            height: 18px;
                        }
                    }
                    
                }
                .filter-lease-term,
                .filter-lease-type,
                .filter-house-type,
                .filter-house-country{
                    padding-top: 20px;
                    .biz-rent-select{
                        padding: 13px 16px;
                        height: 18px;
                    }
                }
                .filter-lease-term{
                    .mx-datepicker-range {
                        width: 228px;
                        input{
                            height: 46px;
                            border-radius: 4px;
                            border: solid 1px #e0dfde;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 18px;
                        }
                    }
                    .mx-datepicker-range:hover,
                    .mx-datepicker-range.active{
                        input{
                            border: 1px solid #676362 !important;
                            color: #676362 !important;
                        }
                        i{
                            color: #676362;
                        }
                    }
                }
                .filter-house-rent{
                    padding-top: 20px;
                    padding-bottom: 40px;
                    .title{
                        margin-bottom: 20px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/personalHome/todoList/graphMode/graphMode.vue